import React, { useEffect, useState } from "react";
import "./Transaction_History.css";
import { Table } from "react-bootstrap";
import Select, { components } from "react-select";
import { Form } from "react-bootstrap";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getTransactionHistory } from "../../../utils/apis/transaction_history/transaction_history";
import { AllTransactionType } from "../../../utils/apis/master/Master";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import "react-toastify/dist/ReactToastify.css";

const Transaction_History = () => {
  const [searchTransactionType, setSearchTransactionType] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [transactionType, setTransactionType] = useState([]);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <FontAwesomeIcon icon={faSortDown} className="custom_dropdown_icon" />
    </components.DropdownIndicator>
  );

  const getTransactionType = async () => {
    const res = await AllTransactionType();
    if (res?.success) {
      const filteredTypes = (res.data?.data || []).filter(
        (type) => type.name !== "Referral Earning"
      );
      setTransactionType([{ id: "", name: "All Types" }, ...filteredTypes]);
    }
  };

  const getHistory = async () => {
    setLoading(true);
    try {
      // Fetch all data (no pagination)
      const res = await getTransactionHistory(
        "",                     // search term
        searchTransactionType,  // type filter
        from,
        to,
        1,                      // dummy page
        10000                   // large number to get everything
      );

      if (res?.success) {
        setTransactionHistory(res.data?.data || []);
      } else {
        toast.error(res?.message || "Failed to load transaction history");
      }
    } catch (error) {
      console.error("Transaction history fetch failed:", error);
      toast.error("Error loading transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTransactionType();
  }, []);

  useEffect(() => {
    getHistory();
  }, [searchTransactionType, from, to]);

  // Filter logic:
  // - "All Types" → only Deposit + Withdrawal
  // - Specific type → only that type
  const visibleData = (transactionHistory || []).filter((val) => {
    const typeName = val?.TransactionType?.name || "";
    if (searchTransactionType === "") {
      return typeName === "Deposit" || typeName === "Withdrawal";
    }
    return typeName === transactionType.find(t => t.id === searchTransactionType)?.name;
  });

  const formatAmount = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  return (
    <section className="transaction-history-page">
      <ToastContainer position="bottom-right" theme="dark" />

      <div className="header-section">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">Transaction History</h1>

      <div className="transaction-content">
        <div className="history-card">
          {/* Filter Bar */}
          <div className="filter-bar">
            <Form className="filter-form">
              <div className="filter-grid max-md:pb-10">
                <div className="filter-item">
                  <label className="filter-label">Transaction Type</label>
                  <Select
                    options={transactionType.map((type) => ({
                      value: type.id,
                      label: type.name,
                    }))}
                    onChange={(selected) => setSearchTransactionType(selected?.value || "")}
                    isClearable
                    placeholder="All Types"
                    className="modern-select"
                    classNamePrefix="select"
                    components={{ DropdownIndicator }}
                    value={
                      searchTransactionType
                        ? {
                            value: searchTransactionType,
                            label: transactionType.find((t) => t.id === searchTransactionType)?.name || "",
                          }
                        : null
                    }
                  />
                </div>

                <div className="filter-item">
                  <label className="filter-label">Start Date</label>
                  <Form.Control
                    type="date"
                    className="modern-date-input"
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                  />
                </div>

                <div className="filter-item">
                  <label className="filter-label">End Date</label>
                  <Form.Control
                    type="date"
                    className="modern-date-input"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                  />
                </div>

                <div className="filter-item reset-wrapper">
                  <button
                    type="button"
                    className="reset-btn !w-fit px-1 right-4 absolute"
                    onClick={() => {
                      setSearchTransactionType("");
                      setFrom("");
                      setTo("");
                    }}
                  >
                    Reset Filters
                  </button>
                </div>
              </div>
            </Form>
          </div>

          {/* Table Section – now scrollable */}
          <div className="table-container max-md:mt-10 max-md:!px-3">
            <div 
              className="table-wrapper overflow-y-auto"
              style={{ maxHeight: "60vh", minHeight: "300px" }} // adjust height as needed
            >
              <Table className="history-table" hover responsive>
                <thead className="sticky top-0 bg-gray-900 z-10">
                  <tr>
                    <th>Sr. No</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Platform Charges</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="no-data-row">
                        <div className="no-data-container">
                          <p className="no-data-text">Loading transactions...</p>
                        </div>
                      </td>
                    </tr>
                  ) : visibleData.length > 0 ? (
                    visibleData.map((val, index) => (
                      <tr key={val.id || `row-${index}`} className="table-row">
                        <td className="sr-no">{index + 1}</td>
                        <td>{val?.TransactionType?.name || "-"}</td>
                        <td className="amount-cell">
                          ${formatAmount(
                            val?.WithdrawRequest?.admin_commission
                              ? Number(val.amount) - Number(val.WithdrawRequest.admin_commission)
                              : Number(val?.amount)
                          )}
                        </td>
                        <td className="fee-cell">
                          ${formatAmount(
                            Number(val?.DepositRequest?.admin_commission) ||
                              Number(val?.WithdrawRequest?.admin_commission) ||
                              0
                          )}
                        </td>
                        <td>
                          {val?.createdAt
                            ? new Date(val.createdAt).toLocaleDateString("en-GB")
                            : "-"}
                        </td>
                        <td>
                          {val?.createdAt
                            ? new Date(val.createdAt).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "-"}
                        </td>
                        <td>
                          <span
                            className={`status-badge ${
                              (val?.WithdrawStatus?.name || "pending").toLowerCase()
                            }`}
                          >
                            {val?.WithdrawStatus?.name || "Pending"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="no-data-row">
                        <div className="no-data-container">
                          <p className="no-data-text">No Transactions Found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Transaction_History;